var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer__secondary-link-wrapper"},[_c('sc-link',{staticClass:"footer__secondary-link",attrs:{"field":this.fields.Link,"editable":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }